import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Components
import VariationImages from "./components/VariationImages";
import WmsItemName from "./components/WmsItemName";
import WmsItemPlaces from "./components/WmsItemPlaces";
import WmsItemCodes from "./components/WmsItemCodes";

WmsItemInformation.propTypes = {
    wmsItem: PropTypes.object.isRequired,
};

function WmsItemInformation({wmsItem, ...props}) {
    const lineItem = wmsItem?.lineItem;

    if (!wmsItem || !lineItem) {
        return null;
    }

    return (
        <div style={{ background: '#FFF', overflow: "auto"}}>
            <VariationImages wmsItem={wmsItem} />
            <Grid container padding={2}>
                <Grid item>
                    <WmsItemName wmsItem={wmsItem} />
                </Grid>
                <Grid
                    container
                    marginTop={2}
                    marginBottom={4}
                    direction={"column"}
                >
                    <Grid item>
                        <WmsItemPlaces wmsItem={wmsItem} />
                    </Grid>
                    <Grid item marginTop={2}>
                        <WmsItemCodes wmsItem={wmsItem}/>
                    </Grid>
                </Grid>
            </Grid>
            <div
                style={{
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    marginBottom: '16px'
                }}
            >
                {props.children}
            </div>
        </div>
    );
}

export default WmsItemInformation;
